import { HostInfo } from '../types/generic';
import { ApiResponseData } from '../types/api';
import * as Http from './http';

let hostLoadPromise: Promise<HostInfo | undefined> | null = null;

export function applyHostApiHost(hostInfo?: HostInfo | null) {
    if (hostInfo?.apiHost && !localStorage.getItem('apihost-override')) {
        Http.setApiHost(hostInfo.apiHost);
    }
}

function unwrapHostInfo(body: unknown): HostInfo | undefined {
    if (!body || typeof body !== 'object') {
        return undefined;
    }
    if ('data' in body && (body as ApiResponseData<HostInfo>).data) {
        return (body as ApiResponseData<HostInfo>).data;
    }
    return body as HostInfo;
}

/** Fetch host.hd.pics for the browser hostname and apply apiHost when present. */
export async function fetchHostInfo(): Promise<HostInfo | undefined> {
    const hostname = window.location.hostname.toLowerCase();
    try {
        const response = await Http.get<unknown>(`https://host.hd.pics/${hostname}`);
        const hostInfo = unwrapHostInfo(response.data);
        applyHostApiHost(hostInfo);
        return hostInfo;
    } catch (error) {
        console.error('Failed to load host info:', error);
        return undefined;
    }
}

/** Shared in-flight/resolved host load for auth + useHost. */
export function ensureHostInfo(): Promise<HostInfo | undefined> {
    if (!hostLoadPromise) {
        hostLoadPromise = fetchHostInfo();
    }
    return hostLoadPromise;
}

/** Drop the shared promise so the next ensureHostInfo/queryFn fetches again. */
export function resetHostLoad() {
    hostLoadPromise = null;
}
